// Saving a downloaded file from the browser, and reading the message out of a failed download (an error body also arrives as a blob)
export const blobText = (blob) => (blob.text ? blob.text() : new Promise((resolve, reject) => {
  const r = new FileReader(); r.onload = () => resolve(r.result); r.onerror = reject; r.readAsText(blob);
}));

export function saveBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  window.URL.revokeObjectURL(url);
}

export async function downloadError(err, fallback) {
  try { return JSON.parse(await blobText(err.response.data)).detail || fallback; } catch (e) { return err.response?.data?.detail || fallback; }
}
